import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isEmpty from 'lodash/isEmpty';
import _isFunction from 'lodash/isFunction';
import { createComponent } from '../../services/components';
import { derivePropsFromObject, getItemKey } from '../../services/props';
export function componentIterator(_ref) {
  var iterator = _ref.iterator,
    component = _ref.component,
    _ref$propMap = _ref.propMap,
    propMap = _ref$propMap === void 0 ? [] : _ref$propMap,
    _ref$itemKey = _ref.itemKey,
    itemKey = _ref$itemKey === void 0 ? '' : _ref$itemKey,
    iteratorObject = _ref[0];
  var finalIterator = iterator;
  if (_isFunction(iterator)) {
    finalIterator = iterator(iteratorObject);
  }
  if (_isEmpty(finalIterator)) {
    return null;
  }
  return finalIterator.map(function (item) {
    var props = _objectSpread(_objectSpread({}, derivePropsFromObject(item, propMap, finalIterator)), {}, {
      key: getItemKey(item, itemKey)
    });
    return createComponent(component, props);
  });
}